export const cachedStories = {
  maxStoryAmount: 0,
  viewed: []
}